<!--
 * @Desc: 数字藏品登录页(因为所依赖的公众号配白名单的名额满了,迂回方案是从数字藏品跳转到H5登录)
 * @Author: may.li
 * @Date: 2023-03-28 09:41:13
 * @LastEditors: may.li
 * @LastEditTime: 2023-04-04 14:56:25
-->
<template>
	<div class="cangpin-login">
		<img :src="publicPath+'statics/images/cangpin/hole-logo.png'" alt="" class="logo-tu">
		<div class="login-title">登录</div>
		<div class="login-form">
			<div class="form-item">
				<van-field v-model="phone" type="tel" clearable placeholder="请输入手机号"></van-field>
				<div class="send-code" @click="getCode">{{ codeBtnDisabled ? delyTime+'s' : '获取验证码' }}</div>
			</div>
			<div class="form-item">
				<van-field v-model="phoneCode" clearable placeholder="请输入验证码"/>
			</div>
		</div>
		<div class="ac-btn" @click="loginFun">登录</div>
		<div class="wechat-wrap">
			<img :src="publicPath+'statics/images/cangpin/wechat-login.png'" alt="" class="wechat-icon" @click="loginWechat">
			<div class="wechat-text">微信快捷登录</div>
		</div>
		<div class="agree-wrap">
			<van-checkbox v-model="checked" checked-color="#0E0E0E">已阅读并同意</van-checkbox>
			<span class="xieyi" @click="goXieyi(27)">《时代藏品用户协议》</span>
			<span class="xieyi" @click="goXieyi(29)">《隐私权政策》</span>
		</div>
		<!-- 勾选协议提示 -->
		<van-popup v-model="showPop" round position="bottom">
			<div class="xieyi-confirm">
				<div class="wenzi">
					请您认真阅读<span class="xieyi" @click="goXieyi(27)">《时代藏品用户协议》</span><span class="xieyi" @click="goXieyi(29)">《隐私权政策》</span>的全部条款 ，接受后可开始时候用我们的服务
				</div>
				<div class="confrim-btns">
					<div class="default-btn" @click="showPop = false">不同意</div>
					<div class="default-btn agree-btn" @click="showPop = false;checked=true;">同意并继续</div>
				</div>
			</div>
		</van-popup>
		<!-- loading -->
		<van-overlay :show="showLoading">
            <div class="wrapper-loading">
				<van-loading type="spinner" />
			</div>
        </van-overlay>
	</div>
</template>
<script>
export default {
	data(){
		return{
			phone: null,
            phoneCode: null,
			delyTime: 60, // 获取验证间隔时间 s
			codeBtnDisabled: false, // 发送验证码可用状态
            checked: false,
			showPop: false,
			redirect: null, // 回跳地址(从数字藏品那边传过来)
			isWechat: false, // 是否在微信环境
			wxCode: null, // 微信code
			showLoading: false,
			getCodeUrl: this.$publicData.domain+"/home/wx-code?url=/cangpin/login", // 拿code
			publicPath: process.env.BASE_URL
		}
	},
	created(){
		this.redirect = this.$route.query.redirect;
		this.checkWeiXin();
	},
	methods: {
		/**
		 * @name: 获取验证码
		 * @return {*}
		 * @desc: 
		 */		
		getCode(){
			let that = this;
            if (that.codeBtnDisabled) {
                return;
            };
            if (!that.phone) {
                that.$toast('请输入手机号');
                return
            } else if (!(/^1[3456789]\d{9}$/.test(that.phone))) {
                that.$toast('请输入合法的手机号');
                return
            }
            let params = {
                phone: that.phone,
                type: 0 // type: 1 // 0普通 1修改手机号 2小程序绑定手机号
            }
            that.codeBtnDisabled = true;
			that.$api.user.code(params).then(res=>{
				if(res.code == 200){
					that.$toast('已发送');
                    let s = setInterval(function () {
                        let dely1 = parseInt(that.delyTime) - 1;
                        that.delyTime = dely1
                        // console.log(dely1);
                        if (dely1 == 0) {
                            // clearInterval(s);
                            that.codeBtnDisabled = false;
                        }
                    }, 1000);
				}else{
					that.codeBtnDisabled = false;
				}
			})
		},
		/**
		 * @name: 手机号登录
		 * @return {*}
		 * @desc: 
		 */		
		loginFun(){
			let that = this;
			if (!that.phone) {
				that.$toast('请输入手机号');
				return;
			} else if (!(/^1[23456789]\d{9}$/.test(that.phone))) {
				that.$toast('请输入合法的手机号');
				return;
			};
			if (!that.phoneCode) {
				that.$toast('请输入验证码');
				return;
			};
			if(!that.checked){
				that.showPop = true;
				return;
			};
			let params = {
				phone: that.phone,
				code: that.phoneCode
			};
			that.$api.user.login(params).then(res=>{
				if(res.code == 200){
					that.$toast('登录成功');
					let token = res.result.user.token;
					that.afterLogin(token,200)
				}else{
					that.$toast(res.message)
				}
			})
		},
		/**
		 * @name: 登录成功
		 * @param {*} token
		 * @param {*} code
		 * @return {*}
		 * @desc: 进数字藏品
		 */		
		afterLogin(token,code){
			let that = this;
			that.showLoading = false;
			let cangpinUrl = this.$publicData.cangpinUrl;
			if(code == 200){
				if(that.redirect){
					let fromArr = that.redirect.split('?');
					let pathUrl = that.redirect.split('?')[0];
					cangpinUrl += pathUrl;
					if(fromArr.length > 1){
						let pathParams = that.redirect.split('?')[1];
						cangpinUrl += '?'+pathParams+'&token='+token;
					}else{
						cangpinUrl += '?token='+token;
					}
					console.log('that.redirect',that.redirect);
					console.log('cangpinUrl',cangpinUrl);
					window.open(cangpinUrl,'_self');
				}else{
					cangpinUrl += '?token='+token;
					console.log('cangpinUrl',cangpinUrl)
					window.open(cangpinUrl,'_self');
				}
			}else if(code == 201){
				// 绑手机号
				cangpinUrl += 'bind/phone?token='+token;
				window.open(cangpinUrl,'_self');
			}
		},
		/**
		 * @name: 微信登录
		 * @return {*}
		 * @desc: 
		 */		
		loginWechat(){
			let that = this;
			if(!that.checked){
				that.showPop = true;
				return;
			};
			if (that.wxCode === null || that.wxCode === undefined || that.wxCode === "") {
                window.location.href = that.getCodeUrl;
                return;
            };
			let params = {
				code: that.wxCode
			};
			this.$api.user.wxlogin(params).then(res=>{
				if(res.code == 200){
					let token = res.result.user.token;
					that.afterLogin(token,200)
				}else if(res.code == 201){
					// 绑手机号
					let token = res.result.token;
					that.afterLogin(token,201);
				}else{
					that.$toast(res.message);
					that.showLoading = false;
				}
			})
		},
		/**
		 * @name: 判断是否在微信环境
		 * @return {*}
		 * @desc: 
		 */		
		checkWeiXin() {
			let that = this;
            let ua = window.navigator.userAgent.toLowerCase()
            if (ua.indexOf('micromessenger') == -1) {
                // console.log("不在微信或者小程序中")
                that.isWechat = false;
            } else {
                // console.log('在微信环境')
                that.isWechat = true;
                let code = that.getUrlCode()['code'];
                // console.log(code)
                if (code != null && code != undefined && code != "") {
					that.showPop = false;
					that.checked = true;
                    that.wxCode = code;
					that.showLoading = true;
                    that.loginWechat();
                };
            }
        },
		/**
		 * @name: 截取url中的code
		 * @return {*}
		 * @desc: 
		 */		
		getUrlCode() {
            let allUrl = location.href;
            let url = allUrl.substring(allUrl.indexOf("?"), allUrl.length);
            let theRequest = new Object();
            if (url.indexOf("?") != -1) {
                let str = url.substr(1);
                let strs = str.split("&");
                for (let i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
                }
            }
            return theRequest;
        },
		/**
		 * @name: 协议
		 * @param {*} id
		 * @return {*}
		 * @desc: 
		 */		
		goXieyi(id){
			this.$router.push({
				path: '/single/page',
				query: {
					id: id
				}
			})
		}
	},
}
</script>
<style scoped>
	.cangpin-login{
		padding: 1.6rem 0.8rem 0;
		background: #FFFFFF;
		min-height: 100vh;
	}
	.cangpin-login .logo-tu{
		display: block;
    	width: 4.186rem;
	}
	.cangpin-login .login-title{
		color: #0E0E0E;
		font-size: .48rem;
		font-weight: bold;
		margin-top: 1.4rem
	}
	.cangpin-login .login-form .form-item{
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 0.4rem;
		border-bottom: 0.0134rem solid #f3f4f9;
	}
	.cangpin-login .login-form .van-cell{
		padding: 0.2rem 0.4rem 0.2rem 0;
    	flex: 1;
	}
	.cangpin-login .login-form .form-item .send-code{
		color: #0E0E0E;
    	font-size: .4rem;
	}
	.cangpin-login .ac-btn{
		width: 100%;
		height: 1.067rem;
		border-radius: 0.6rem;
		background: #0E0E0E;
		font-size: .4rem;
		font-weight: bold;
		color: #FFFFFF;
		text-align: center;
		line-height: 1.067rem;
		margin-top: 2rem;
	}
	.cangpin-login .wechat-wrap{
		text-align: center;
		font-size: .32rem;
		color: #999999;
		margin-top: 3.2rem;
	}
	.cangpin-login .wechat-wrap .wechat-icon{
		display: block;
		width: 0.8rem;
		margin: 0 auto 0.2rem;
		pointer-events: auto;
	}
	.cangpin-login .agree-wrap{
		margin-top: 0.8rem;
		display: flex;
		align-items: center;
		font-size: .32rem;
		color: #999999;
	}
	.cangpin-login .agree-wrap .xieyi{
		color: #0E0E0E;
    	font-weight: bold;
	}
	.cangpin-login .xieyi-confirm{
		padding: 0.8rem;
		font-size: .4rem;
		color: #999999;
	}
	.cangpin-login .xieyi-confirm .confrim-btns{
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 0.53rem;
	}
	.cangpin-login .xieyi-confirm .default-btn{
		width: 3.467rem;
		height: 1.067rem;
		border-radius: 0.53rem;
		border: 0.0267rem solid #E9E9E9;
		font-size: .426rem;
		display: flex;
		align-items: center;
		justify-content: center;
		line-height: unset;
	}
	.cangpin-login .xieyi-confirm .default-btn.agree-btn{
		border: 0 none;
		color: #ffffff;
		background: #0E0E0E;
	}
	.cangpin-login .van-cell::after{
		display: none;
	}
	.wrapper-loading{
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
	}
</style>